module.exports = __webpack_public_path__ + "images/people-a9713bed0a398b0d68b8b6453216650a.png";